export const START_FETCHING_VISIBILITY_BOOST = "START_FETCHING_VISIBILITY_BOOST";
export const ERROR_FETCHING_VISIBILITY_BOOST = "ERROR_FETCHING_VISIBILITY_BOOST";
export const SAVE_VISIBILITY_BOOST = "SAVE_VISIBILITY_BOOST";
// FOR FETCHING BOOST_DATA

export const START_SUBSCRIBING_VISIBILITY_BOOST = "START_SUBSCRIBING_VISIBILITY_BOOST";
export const ERROR_SUBSCRIBING_VISIBILITY_BOOST = "ERROR_SUBSCRIBING_VISIBILITY_BOOST";
export const SAVE_SUBSCRIBED_VISIBILITY_BOOST = "SAVE_SUBSCRIBED_VISIBILITY_BOOST";
// FOR SUBSCRIBING BOOST